import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6342e6b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modalBackdrop flex absolute z-max" }
const _hoisted_2 = { class: "c4c-modal" }
const _hoisted_3 = { class: "panelheader" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "headerTitle" }, "PLUS Metrics", -1))
const _hoisted_5 = { "aria-hidden": "true" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text" }, "Close", -1))
const _hoisted_7 = { class: "panleBody" }
const _hoisted_8 = {
  id: "facilityAndDept",
  class: "paddingBottom-10 mx-4"
}
const _hoisted_9 = { class: "mb-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Pay Period ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Entire Month ", -1))
const _hoisted_12 = {
  key: 0,
  id: "payperiod-details",
  class: "panelTabData scrollBar",
  role: "tabpanel",
  "aria-labelledby": "contract-labor-home-tab"
}
const _hoisted_13 = {
  id: "period-content",
  class: "mt-3"
}
const _hoisted_14 = {
  key: 0,
  id: "period-message",
  class: "text-center mt-3"
}
const _hoisted_15 = { id: "period-message-text" }
const _hoisted_16 = {
  key: 1,
  id: "entiremonth-details",
  class: "panelTabData scrollBar",
  role: "tabpanel",
  "aria-labelledby": "contract-labor-profile-tab"
}
const _hoisted_17 = {
  id: "month-content",
  class: "mt-3"
}
const _hoisted_18 = {
  key: 0,
  id: "month-message",
  class: "text-center mt-3"
}
const _hoisted_19 = { id: "month-message-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_tab = _resolveComponent("neu-tab")!
  const _component_neu_tablist = _resolveComponent("neu-tablist")!
  const _component_neu_table_heading = _resolveComponent("neu-table-heading")!
  const _component_neu_table_row = _resolveComponent("neu-table-row")!
  const _component_neu_label = _resolveComponent("neu-label")!
  const _component_neu_table_body = _resolveComponent("neu-table-body")!
  const _component_neu_table = _resolveComponent("neu-table")!
  const _component_neu_card = _resolveComponent("neu-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("a", {
          href: "#",
          class: "closeBtn neu-tooltip",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, [
          _createElementVNode("i", _hoisted_5, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'close'],
              size: "lg"
            })
          ]),
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.facilityName) + " > " + _toDisplayString(_ctx.departmentName), 1),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_neu_tablist, {
            value: _ctx.selectedTab,
            class: "mx-4 tabList"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_neu_tab, {
                white: "",
                tab: "payperiod-tab",
                onClick: _ctx.showPayPeriodTab
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_neu_tab, {
                white: "",
                tab: "entiremonth-tab",
                "payperiod-tab": "",
                "entiremonth-tab": "",
                onClick: _ctx.showEntireMonthTab
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        (_ctx.isPayPeriodVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_neu_card, {
                  color: "plain-0",
                  class: "p-0 m-0"
                }, {
                  default: _withCtx(() => [
                    (_ctx.PlusMetricsPayPeriod != null && _ctx.PlusMetricsPayPeriod.length > 0)
                      ? (_openBlock(), _createBlock(_component_neu_table, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_neu_table_row, {
                              columns: _ctx.columnHeaders,
                              header: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeaders), (column) => {
                                  return (_openBlock(), _createBlock(_component_neu_table_heading, {
                                    key: column,
                                    icon: _ctx.columnIcons[column],
                                    slot: column
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(column), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["icon", "slot"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["columns"]),
                            _createVNode(_component_neu_table_body, { align: "left" }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PlusMetricsPayPeriod, (payPeriod, index) => {
                                  return (_openBlock(), _createBlock(_component_neu_table_row, {
                                    columns: _ctx.columnHeaders,
                                    key: payPeriod,
                                    slot: _ctx.column
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_neu_label, {
                                        slot: "Date",
                                        class: _normalizeClass([index == (_ctx.PlusMetricsPayPeriod.length - 1) ? 'digits': ''])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(payPeriod.date != 'Total' ? _ctx.getFormattedDate(payPeriod.date) : payPeriod.date), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"]),
                                      _createVNode(_component_neu_label, {
                                        slot: "Target",
                                        class: _normalizeClass([index == (_ctx.PlusMetricsPayPeriod.length - 1) ? 'digits': ''])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(payPeriod.targetHours), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"]),
                                      _createVNode(_component_neu_label, {
                                        slot: "Actual",
                                        class: _normalizeClass([index == (_ctx.PlusMetricsPayPeriod.length - 1) ? 'digits': ''])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(payPeriod.actualHours), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"]),
                                      _createVNode(_component_neu_label, {
                                        slot: "Difference",
                                        class: _normalizeClass([payPeriod.varianceHours < 0 ? 'red': '',
                                                                         index == (_ctx.PlusMetricsPayPeriod.length - 1) ? 'digits': ''])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getVarianceHours(payPeriod.varianceHours)), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"])
                                    ]),
                                    _: 2
                                  }, 1032, ["columns", "slot"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              (_ctx.isPeriodMessageVisible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.periodMessage), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isEntireMonthVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_neu_card, {
                  color: "plain-0",
                  class: "p-0 m-0"
                }, {
                  default: _withCtx(() => [
                    (_ctx.PlusMetricsMonth != null && _ctx.PlusMetricsMonth.length > 0)
                      ? (_openBlock(), _createBlock(_component_neu_table, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_neu_table_row, {
                              columns: _ctx.columnHeaders,
                              header: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeaders), (column) => {
                                  return (_openBlock(), _createBlock(_component_neu_table_heading, {
                                    key: column,
                                    icon: _ctx.columnIcons[column],
                                    slot: column
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(column), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["icon", "slot"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["columns"]),
                            _createVNode(_component_neu_table_body, { align: "left" }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PlusMetricsMonth, (payPeriod, index) => {
                                  return (_openBlock(), _createBlock(_component_neu_table_row, {
                                    columns: _ctx.columnHeaders,
                                    key: payPeriod,
                                    slot: _ctx.column
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_neu_label, {
                                        slot: "Date",
                                        class: _normalizeClass([index == (_ctx.PlusMetricsMonth.length - 1) ? 'digits': ''])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(payPeriod.date != 'Total' ? _ctx.getFormattedDate(payPeriod.date) : payPeriod.date), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"]),
                                      _createVNode(_component_neu_label, {
                                        slot: "Target",
                                        class: _normalizeClass([index == (_ctx.PlusMetricsMonth.length - 1) ? 'digits': ''])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(payPeriod.targetHours), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"]),
                                      _createVNode(_component_neu_label, {
                                        slot: "Actual",
                                        class: _normalizeClass([index == (_ctx.PlusMetricsMonth.length - 1) ? 'digits': ''])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(payPeriod.actualHours), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"]),
                                      _createVNode(_component_neu_label, {
                                        slot: "Difference",
                                        class: _normalizeClass([payPeriod.varianceHours < 0 ? 'red': '',
                                                                         index == (_ctx.PlusMetricsMonth.length - 1) ? 'digits': ''])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getVarianceHours(payPeriod.varianceHours)), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"])
                                    ]),
                                    _: 2
                                  }, 1032, ["columns", "slot"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              (_ctx.isMonthMessageVisible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.monthMessage), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}